<template>
  <v-switch
    inset
    v-model="localAudioEnabled"
    :label="`${this.audioEnabled
        ? t('accessibilitySettings.audioSettingsOn')
        : t('accessibilitySettings.audioSettingsOff')}`"
    :false-icon="'mdi-volume-off'"
    :true-icon="'mdi-volume-high'"
    :class="{
      'speech-switch-on': this.audioEnabled,
      'speech-switch-off': !this.audioEnabled,
    }"
  >
  </v-switch>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data: () => ({
    localAudioEnabled: true,
  }),
  computed: {
    ...mapState(["audioEnabled"]),
  },
  methods: {
    ...mapActions(["updateAudio" ]),
  },
  watch: {
    localAudioEnabled() {
      this.updateAudio(this.localAudioEnabled);
    },
    },
  created() {    
    this.localAudioEnabled = this.audioEnabled;
  },
};
</script>

<style>
.speech-switch-on,
.speech-switch-off {
  --v-switch-track-height: 24px;
  --v-switch-thumb-size: 24px;
  --v-switch-track-width: 48px;
  transform: scale(1.25);
  transform-origin: left center;
  margin: 0;
  margin-left: 32px;
  width: 100%;
}
.speech-switch-on .mdi-volume-high,
.speech-switch-on .mdi-brightness-5 {
  color: white;
  font-size: 21px;
  color: red;
}
.speech-switch-off .mdi-volume-off,
.speech-switch-off .mdi-brightness-3 {
  color: white;
  font-size: 14px;
  background: black;
}
.speech-switch-off .v-switch__thumb {
  background: black;
}

@media (max-width: 768px) {
  .speech-switch-on,
  .speech-switch-off {
    transform: scale(1.25);
  }
}
</style>